import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import headshot from '../../assets/headshot.jpg';

const Hero = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section 
      ref={ref} 
      className="relative min-h-[100vh] flex items-center justify-center bg-hero-pattern bg-cover bg-center py-12 md:py-0 dark:bg-secondary-950"
    >
      <div className="absolute inset-0 bg-secondary-900 bg-opacity-70 dark:bg-opacity-80"></div>

      <div className="container mx-auto px-8 z-10">
        <div className="flex flex-col md:flex-row items-center gap-10 max-w-5xl mx-auto">

          {/* Headshot */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6 }}
            className="flex-shrink-0"
          >
            <div className="relative w-48 h-48 md:w-56 md:h-56 overflow-hidden rounded-full border-4 border-primary-500 shadow-xl">
              <img
                src={headshot}
                alt="Gerald Suleh"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/300?text=Gerald+Suleh';
                }}
              />
            </div>
          </motion.div>

          {/* Text + Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex-1 text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-1">
              Gerald Suleh
            </h1>
            <p className="text-primary-400 dark:text-primary-300 text-lg md:text-xl font-semibold mb-1">
              Senior Engineer — Security Operations Center, USIU-Africa
            </p>
            <p className="text-secondary-300 text-sm md:text-base mb-3">
              Cybersecurity & Digital Resilience Lead
            </p>
            <p className="text-secondary-100 text-base leading-relaxed mb-6">
              Building and operationalizing enterprise security programs, from standing up Security Operations Centres and engineering agentic threat automation to penetration testing, intelligent backend systems, and blockchain identity infrastructure. Published researcher, educator, mentor, and cybersecurity leader.
            </p>
            <div className="flex flex-row flex-wrap gap-4 w-full justify-center">
              <Link
                to="/portfolio"
                className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-md transition-colors duration-300 text-center"
              >
                View Technical Projects
              </Link>
              <a
                href="/Gerald_Suleh_-_Senior_Engineer-SOC.pdf"
                download="Gerald_Suleh_-_Senior_Engineer-SOC.pdf"
                className="bg-transparent border-2 border-white hover:bg-white hover:text-secondary-900 text-white px-8 py-3 rounded-md transition-colors duration-300 text-center"
              >
                Download CV
              </a>
            </div>
          </motion.div>

        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="animate-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;

